import { Identifier } from "../../id";
export class CustomParameterChoiceId extends Identifier {
    constructor(id) {
        super("CustomParameterChoiceId", id);
    }
}
